import { useCallback, useContext, useEffect, useState } from "react";
import Ticketdetails from "../../../../../../../images/Ticket_Details.svg";
import DownArrow from "../../../../../../../images/DownArrow.svg";
import VendorReply from "../../../../../../../images/VendorReply.svg";
import {
  CustomTooltip,
  TooltipForMultipleOption,
} from "../../../../../../../styles/TooltipStyles";
import { TOOLTIP_COLORS } from "../../../../../../../styles/Variables";
import {
  convertToTimeZone,
  CustomModal,
  ticketStatusClassName,
} from "../../../../../../../utils/UtilFunctions";
import {
  EditMessageModalStyles,
  ImageModalStylesInTickets,
} from "../../../../../../../styles/CustomModalStyles";
import EditVendorResponse from "./EditVendorResponse";
import ViewMore from "../../../../../../../images/ArrowRight.svg";
import { AppContext } from "../../../../../../../context/context";
import Information from "../../../../../../../images/Info.svg";
import {
  AssetViewDrawer,
  CustomDrawer,
} from "../../../../../../../styles/CustomDrawerStyles";
import DetailedView from "./DetailedView";
import { useLazyQuery } from "@apollo/client";
import {
  AtsTicketsByNodeData,
  AtsTicketsByNodeForStatus,
  GetTicketDetailsForFollowUp,
} from "../../../../masters/items/queries/queries";
import {
  GetTicketDetailsResult,
  GetTicketDetailsVars,
} from "../../../../masters/items/queries/types";
import AddFollowUpStatus from "../../history/AddFollowUpStatus";

import useUrlParams from "../../../../../../../customHooks/useUrlParams";
import { MapsContext } from "../../../context/context";
import { getDownloadUrl } from "../../../../../../../utils/DownloadFile";
import {
  EMPTY_STRING,
  TicketStatus,
} from "../../../../../../../utils/constants";
import { empType, TimeZone } from "../../../../../../../utils/Enum.types";
import { AtsTicketDetails } from "../../../queries/types";
import { nodeVar } from "../../../../../../../utils/commonQueryTypes";
import { mapsPayloadType } from "../../../context/reducer";
import ImageIcon from "../../../../../../../images/DownloadImage.svg";
import { Title } from "../../../../../../../stories/Title/Title";
import Close from "../../../../../../../images/Close.svg";
interface ticketDetailsList extends AtsTicketDetails {
  flag: boolean;
  image: string;
}
const FollowUpItemStatus = () => {
  const { state, dispatch } = useContext(MapsContext);
  const { state: globalState } = useContext(AppContext);

  const [editModal, setEditModal] = useState(false);
  const [ticketDetailsModal, setTicketDetailsModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);

  const [ticketDetails, setTicketDetails] = useState<ticketDetailsList[]>([]);

  const { customer_id } = useUrlParams();
  const [GetTicketsFollowUp, { data: followUpData }] = useLazyQuery<
    GetTicketDetailsResult,
    GetTicketDetailsVars
  >(GetTicketDetailsForFollowUp);

  const [GetTicketById, { data }] = useLazyQuery<AtsTicketsByNodeData, nodeVar>(
    AtsTicketsByNodeForStatus
  );
  useEffect(() => {
    if (state.ticketId) {
      GetTicketById({
        variables: {
          id: state.ticketId,
        },
      });
    }
  }, [state.ticketId, GetTicketById, data]);

  useEffect(() => {
    if (customer_id && state.ticketId) {
      GetTicketsFollowUp({
        variables: {
          customerID: customer_id!,
          ticketID: state.ticketId,
        },
      }).then(({ data }) => {
        if (data && data.GetTicketDetails) {
          const updateData = data.GetTicketDetails.map((ticket) => {
            return {
              ...ticket,
              flag: false,
              image: EMPTY_STRING,
            };
          });

          setTicketDetails(updateData);
        }
      });
    }
  }, [
    customer_id,
    GetTicketsFollowUp,
    state.companyId,
    followUpData,
    state.ticketId,
  ]);

  const hideAddFollowUp = useCallback(() => {
    if (data) {
      switch (data.node.status) {
        case TicketStatus.OPEN:
        case TicketStatus.ASSIGNED:
        case TicketStatus.RE_OPENED:
          return true;
        case TicketStatus.RESOLVED:
          if (
            globalState.empSubType === empType.TECHNICIAN ||
            globalState.empSubType === empType.VENDOR_MANAGER
          )
            return false;
          else return true;
        default:
          return false;
      }
    } else {
      return false;
    }
  }, [data, globalState.empSubType]);

  return (
    <div className="junc-follow-up">
      <div className="junc-follow-up__header">
        <div className="junc-follow-up__header--flex">
          <img src={Ticketdetails} alt="" />
          <b>Ticket Details</b>
        </div>
        <CustomTooltip
          title="View Ticket Details"
          arrow
          placement="top"
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: TOOLTIP_COLORS.GREY,
                "& .MuiTooltip-arrow": {
                  color: TOOLTIP_COLORS.GREY,
                },
              },
            },
          }}
        >
          <img
            src={Information}
            alt=""
            onClick={() => {
              setTicketDetailsModal(!ticketDetailsModal);
            }}
          />
        </CustomTooltip>
      </div>

      <div className="junc-follow-up__data">
        {data ? hideAddFollowUp() ? <AddFollowUpStatus /> : null : null}
        <div
          className={`junc-follow-up__data--remarks${
            data
              ? hideAddFollowUp() &&
                globalState.empSubType !== empType.VENDOR_MANAGER
                ? "--with-add"
                : hideAddFollowUp() &&
                  globalState.empSubType === empType.VENDOR_MANAGER
                ? "--with-vendor"
                : ""
              : ""
          }`}
        >
          <ul>
            {ticketDetails ? (
              ticketDetails.map((res, index) => {
                return (
                  <li key={index} className="junc-follow-up__data--remarks--li">
                    <div className="junc-follow-up__data--remarks--comments">
                      <div className="junc-follow-up__data--remarks--flex--b">
                        <div>
                          <b>{res.createdUserDetails.name}, </b>
                          <span className="font-grey">
                            {res.createdUserDetails.empType}
                          </span>
                        </div>
                        <span>{res.remarks}</span>
                        <div className="junc-follow-up__data--remarks--flex--status">
                          <span className={ticketStatusClassName(res.status)}>
                            {res.status}
                          </span>
                        </div>

                        {res.imagesPath ? (
                          <>
                            <img
                              src={ImageIcon}
                              alt=""
                              className="junc-follow-up__data--remarks--flex--view"
                              onClick={async () => {
                                let img = "";

                                if (res.imagesPath.length) {
                                  const files = res.imagesPath.split(".");

                                  const ext = files.length
                                    ? files[files.length - 1]
                                    : EMPTY_STRING;

                                  const filename = `${res.companyID}/ticketDetails/${res.id}_0.${ext}`;
                                  try {
                                    const ers = await getDownloadUrl(
                                      filename,
                                      false
                                    );
                                    img = ers;

                                    const updatedData = ticketDetails.map(
                                      (ticket) => {
                                        if (ticket.flag === false)
                                          if (ticket.id === res.id) {
                                            return {
                                              ...ticket,
                                              flag: true,
                                              image: ers,
                                            };
                                          } else {
                                            return ticket;
                                          }
                                        else {
                                          return { ...ticket, flag: false };
                                        }
                                      }
                                    );
                                    setTicketDetails(updatedData);
                                    setImageModal(!imageModal);
                                  } catch (err) {
                                    console.error(err as Error);
                                  }
                                }
                              }}
                            />
                            <CustomModal
                              isOpen={imageModal}
                              onRequestClose={() => setImageModal(!imageModal)}
                              contentComponent={
                                <>
                                  <div className="edit-vendor-response__title">
                                    <Title>Image details</Title>
                                    <img
                                      src={Close}
                                      alt=""
                                      onClick={() => setImageModal(!imageModal)}
                                    />
                                  </div>
                                  {res.flag && res.image && (
                                    <div
                                      className={`junc-follow-up__data--remarks--flex--image-container ${
                                        res.flag && res.image ? "open" : ""
                                      }`}
                                    >
                                      <img
                                        className="junc-follow-up__data--remarks--flex--image"
                                        src={res.image}
                                        alt=""
                                      />
                                    </div>
                                  )}
                                </>
                              }
                              style={ImageModalStylesInTickets}
                            />
                          </>
                        ) : null}
                      </div>

                      <div className="junc-follow-up__data--remarks--flex--time">
                        <div>
                          <span className="font-grey">
                            {
                              convertToTimeZone(
                                TimeZone.Asia_Kolkata,
                                res.attendedDate
                              ).timeAndDate
                            }
                          </span>
                        </div>
                        <TooltipForMultipleOption
                          title={
                            <ul className="purchase-order__select--li">
                              <li
                                className="font-blue"
                                onClick={() => {
                                  dispatch({
                                    type: mapsPayloadType.TICKET_DETAILS,
                                    payload: {
                                      ticketDetailsId: res.id,
                                    },
                                  });
                                  setEditModal(!editModal);
                                }}
                              >
                                Edit
                              </li>
                              {/* <li
                                className="font-red"
                                onClick={() => setDeletModal(!deleteModal)}
                              >
                                Delete
                              </li> */}
                            </ul>
                          }
                          placement="bottom"
                          slotProps={{
                            tooltip: {
                              sx: {
                                bgcolor: TOOLTIP_COLORS.GREY,
                                "& .MuiTooltip-arrow": {
                                  color: TOOLTIP_COLORS.GREY,
                                },
                              },
                            },
                          }}
                        >
                          <img src={DownArrow} alt="" />
                        </TooltipForMultipleOption>{" "}
                      </div>
                    </div>
                  </li>
                );
              })
            ) : (
              <div className="junc-follow-up__data--remarks--block">
                <img
                  src={VendorReply}
                  alt=""
                  className="junc-follow-up__data--remarks--block--image"
                />
                <b className="junc-follow-up__data--remarks--block--text">
                  Wait for the Vendor Reply
                </b>
              </div>
            )}

            {/* to be discussed with santhosh */}
            {/* 
            <li className="junc-follow-up__data--remarks--li">
              <div className="junc-follow-up__data--remarks--flex">
                <b>Previously entered remarks</b>
                <div>
                  <span className="font-grey">10/02/2025 5:30pm </span>
                  <TooltipForMultipleOption
                    title={
                      <ul className="purchase-order__select--li">
                        <li
                          className="font-blue"
                          onClick={() => setEditModal(!editModal)}
                        >
                          Edit
                        </li>
                        <li
                          className="font-red"
                          onClick={() => setDeletModal(!deleteModal)}
                        >
                          Delete
                        </li>
                      </ul>
                    }
                    placement="bottom"
                    slotProps={{
                      tooltip: {
                        sx: {
                          bgcolor: TOOLTIP_COLORS.GREY,
                          "& .MuiTooltip-arrow": {
                            color: TOOLTIP_COLORS.GREY,
                          },
                        },
                      },
                    }}
                  >
                    <span>
                      <img src={DownArrow} alt="" />
                    </span>
                  </TooltipForMultipleOption>{" "}
                </div>
              </div>
            </li> */}
            {/* {showVendorResponse && (
              <li className="junc-follow-up__data--remarks--li">
                <div className="junc-follow-up__data--remarks--flex">
                  <b>Previously entered remarks</b>
                  <div>
                    <span className="font-grey">10/02/2025 5:30pm </span>
                    <TooltipForMultipleOption
                      title={
                        <ul className="purchase-order__select--li">
                          <li
                            className="font-blue"
                            onClick={() => setEditModal(!editModal)}
                          >
                            Edit
                          </li>
                          <li
                            className="font-red"
                            onClick={() => setDeletModal(!deleteModal)}
                          >
                            Delete
                          </li>
                        </ul>
                      }
                      placement="bottom"
                      slotProps={{
                        tooltip: {
                          sx: {
                            bgcolor: TOOLTIP_COLORS.GREY,
                            "& .MuiTooltip-arrow": {
                              color: TOOLTIP_COLORS.GREY,
                            },
                          },
                        },
                      }}
                    >
                      <span>
                        <img src={DownArrow} alt="" />
                      </span>
                    </TooltipForMultipleOption>
                  </div>
                </div>
              </li>
            )} */}
          </ul>
        </div>
      </div>
      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        contentComponent={<EditVendorResponse setModalFlag={setEditModal} />}
        style={EditMessageModalStyles}
      />

      <AssetViewDrawer
        anchor="right"
        open={ticketDetailsModal}
        onClose={() => setTicketDetailsModal(!ticketDetailsModal)}
      >
        <DetailedView setModalFlag={setTicketDetailsModal} />
      </AssetViewDrawer>
    </div>
  );
};

export default FollowUpItemStatus;
